import { render, staticRenderFns } from "./Leadership.vue?vue&type=template&id=2dfeeffe&"
import script from "./Leadership.vue?vue&type=script&lang=js&"
export * from "./Leadership.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports